import { useUnit } from 'effector-react';
import { $separatedDots } from '../../models/investProModel/index.js';
import InvestProDotsLayer from './InvestProLayers/InvestProDotsLayer.jsx';
import {
  layers_colors_dictionary,
  layers_icons_dictionary,
} from '../../dictionaries/layers_dictionary.js';

function InvestProjectsLayerManager() {
  const separatedDots = useUnit($separatedDots);

  return (
    <>
      {Object.keys(separatedDots).map((item) => {
        return (
          <InvestProDotsLayer
            key={`invest_pro_${item}`}
            dots={separatedDots[item]}
            color={layers_colors_dictionary[item]}
            genName={item}
            icon={layers_icons_dictionary[item]}
          />
        );
      })}
    </>
  );
}

export default InvestProjectsLayerManager;
